module.exports = __webpack_public_path__ + "img/charging-user-APP.83f8e659.png";